<template>
	<section>
		<b-row>
			<b-col>
		<b-img fluid :src="require('../assets/ouraim.png')" class="rounded-0"></b-img>
		<h1 class="h2 mt-2 text-uppercase">Our Aim</h1>
		<p>We aim to cater for all your rotary engine needs, from general servicing and maintenance to bespoke rebuilds.</p>
		<b-img fluid v-b-tooltip.hover title="Mazda 10A housing" :src="require('../assets/housings.png')" class="rounded-0"></b-img>
			<p class="mt-2">
				Our extensive knowledge of the rotary engine family enables us to offer quality workmanship and advice. Our team has over 40 years of combined experience working with rotary engines.
			</p>

		</b-col>
	</b-row>
	</section>
</template>
<script>
export default {
  name: 'OurAim',
  props: {
    msg: String
  }
}
</script>